import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { axiosTokenInstance } from "../../axiosConfig/axios";
import { Button } from "react-bootstrap";
import "react-toastify/dist/ReactToastify.css";
import { toast, ToastContainer } from "react-toastify";

const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(38, 38, 38, 0.5)",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
    alignItems: "center",
    zIndex: 9999,
  },
  box: {
    backgroundColor: "white",
    padding: "60px 18px",
    borderRadius: "24px 24px 0 0",
    width: "100%",
    border: "1px solid grey",
  },

  inner_box: {
    width: "100%",
    maxWidth: "400px",
    padding: "20px",
    borderRadius: "8px",
  },
  input: {
    width: "100%",
    padding: "15px 10px",
    marginTop: "3px",
    fontSize: "14px",
    borderRadius: "10px",
    border: "1px solid #ccc",
    outline: "none",
  },
  buttons: {
    marginTop: "20px",
    display: "flex",
    justifyContent: "space-between",
    gap: "10px",
  },
  payBtn: {
    flex: 1,
    padding: "14px 10px",
    backgroundColor: "#27ae60",
    color: "white",
    border: "none",
    borderRadius: "10x",
    cursor: "pointer",
  },
  cancelBtn: {
    flex: 1,
    padding: "14px 10px",
    backgroundColor: "transparent",
    color: "#e74c3c",
    border: "1px solid #e74c3c",
    borderRadius: "10px",
    cursor: "pointer",
  },
};

const SplitOrder = ({ setIsOpen, promotion_id }) => {
  const order_id = localStorage.getItem("order-id");

  const [remainingAmount, setRemainingAmount] = useState({});
  const [amount, setAmount] = useState("");
  const navigate = useNavigate();

  // get order product details
  const getOrderDetails = () => {
    axiosTokenInstance
      .get(`/connector/api/users/order/${order_id}`)
      .then((res) => {
        setRemainingAmount(res.data.data?.due);
      });
  };

  useEffect(() => {
    getOrderDetails();
  }, []);

  const sharePayment = () => {
    if (!amount || isNaN(amount) || Number(amount) <= 0) {
      toast.error("من فضلك أدخل مبلغ صحيح", {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 2000,
      });
      return;
    }

    if (Number(amount) > Number(remainingAmount)) {
      toast.error("المبلغ الذى أدخلته أكبر من المتبقي", {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 2000,
      });
      return;
    }

    axiosTokenInstance
      .post(`/connector/api/users/order/partial-pay/${order_id}`, {
        amount,
        promotion_id: promotion_id ?? null,
        payment_from: "web-view",
      })
      .then((res) => {
        if (res.data?.payment_url) {
          window.location.href = res.data.payment_url;
        } else {
          console.error("Redirect URL not found!");
        }
      })
      .catch((err) => {
        console.error("Error sharing payment:", err?.response?.data?.message);
      });
  };

  const cancel = () => {
    setIsOpen(false);
  };

  return (
    <>
      <div style={styles.overlay}>
        <div style={styles.box}>
          <h2
            style={{
              textAlign: "center",
              fontSize: "18px",
              fontWeight: "bold",
            }}
          >
            دفع جزء من الطلب{" "}
          </h2>
          <div>
            <h3
              style={{
                fontSize: "15px",
              }}
            >
              المبلغ المطلوب دفعه{" "}
            </h3>
            <input
              type="number"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              placeholder="أدخل المبلغ"
              style={styles.input}
            />
          </div>
          <div style={styles.buttons}>
            <Button style={styles.payBtn} onClick={sharePayment}>
              دفع
            </Button>
            <Button style={styles.cancelBtn} onClick={cancel}>
              إلغاء
            </Button>
          </div>
        </div>
      </div>
      <ToastContainer />
    </>
  );
};

export default SplitOrder;
